import React from "react";
import SITE from "../services/siteConfig";

export default function Tos() {
  const S = { color: "var(--text-primary)", lineHeight: 1.7, fontSize: "0.88rem", marginBottom: "1rem" };
  const H = { color: "var(--text-primary)", fontSize: "1.1rem", fontWeight: 700, margin: "1.5rem 0 0.5rem 0" };
  const SH = { color: "var(--text-primary)", fontSize: "0.92rem", fontWeight: 600, margin: "1rem 0 0.25rem 0" };
  const P = { color: "var(--text-secondary)", fontSize: "0.85rem", lineHeight: 1.7, margin: "0 0 0.75rem 0" };

  return (
    <div style={{
      minHeight: "100vh",
      background: "var(--bg-secondary)",
      display: "flex", justifyContent: "center",
      padding: "2rem 1rem",
    }}>
      <div style={{
        maxWidth: 780, width: "100%",
        background: "var(--bg-card)",
        borderRadius: "var(--radius-lg)",
        border: "1px solid var(--border)",
        padding: "2.5rem 2rem",
        boxShadow: "var(--shadow-md)",
      }}>
        <h1 style={{...H, fontSize:"1.5rem", margin:"0 0 0.25rem 0"}}>Terms of Service</h1>
        <p style={P}>Last updated: {new Date().getFullYear()}</p>

        <h2 style={H}>1. Introduction</h2>
        <p style={P}>By using our platform, you agree to these Terms. International American Massage & Body Professional provides secure third-party payment holding and disbursement services.</p>

        <h2 style={H}>2. Service Description</h2>
        <h3 style={SH}>Core Services</h3>
        <p style={P}>Secure fund holding, transaction verification, fund disbursement upon condition fulfillment, and dispute resolution.</p>

        <h2 style={H}>3. Fees</h2>
        <p style={P}>Escrow fees based on transaction value, payment processing fees, and currency conversion fees where applicable. Fees are non-refundable unless required by law.</p>

        <h2 style={H}>4. Prohibited Transactions</h2>
        <p style={P}>Illegal goods/services, controlled substances, weapons, counterfeit items, or any items prohibited by law.</p>

        <h2 style={H}>5. Contact</h2>
        <p style={P}>Email: {SITE.email} | Phone: {SITE.phone}</p>

        <p style={{...S, textAlign:"center", marginTop:"2rem", paddingTop:"1.5rem", borderTop:"1px solid var(--border)", color:"var(--text-muted)", fontSize:"0.78rem" }}>
          By using our services, you acknowledge reading and agreeing to these Terms of Service.
        </p>
      </div>
    </div>
  );
}